import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (localStorage.getItem('token')) {
            return true;
        }
        // this.router.navigate(['/landing-page'], { queryParams: { returnUrl: state.url } });
        this.router.navigate(['/landing-page']); // , { queryParams: { returnUrl: state.url } });
        return false;
    }
}



// WEBPACK FOOTER //
// ./public/app/_services/authguard.service.ts